// src/lib/planApi.ts — planning-domain read/write client + shapes. Mirrors the
// API line-data.ts PlanDay / DayNote (the row→prototype-shape chokepoint).

import { apiFetch } from "../api";

export interface DayNote {
  id: string; date: string; dept: string; pr: string; text: string; by: string; ts: string;
  published: boolean; override: boolean; merac: boolean; ack: string[]; mentions: string[];
}
export interface PlanDay {
  date: string; dow: string; dnum: number; month: number; year: number; tt: string;
  merac: boolean; label: string | null; events: string[];
  sets: Record<string, string>; locos: Record<string, string>; notes: DayNote[];
}
export interface DaysResponse { today: string; days: PlanDay[]; }
export interface NoteInput { dept: string; pr: string; text: string; mentions: string[]; }

export const getDays = () => apiFetch<DaysResponse>("/api/days");

export const postNote = (date: string, body: NoteInput) =>
  apiFetch<{ ok: boolean; note: DayNote }>(`/api/day/${encodeURIComponent(date)}/note`, { method: "POST", body: JSON.stringify(body) });

export const ackNote = (id: string) =>
  apiFetch<{ ok: boolean; ack: string[] }>(`/api/note/${encodeURIComponent(id)}/ack`, { method: "POST" });

export const editNote = (id: string, body: NoteInput) =>
  apiFetch<{ ok: boolean; date: string }>(`/api/note/${encodeURIComponent(id)}`, { method: "PATCH", body: JSON.stringify(body) });

export const deleteNote = (id: string) =>
  apiFetch<{ ok: boolean; date: string }>(`/api/note/${encodeURIComponent(id)}`, { method: "DELETE" });
